import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import React, { useState, useEffect } from "react";

import { UpwardTimerPropsInterface } from "./UpwardTimer";

dayjs.extend(duration);
dayjs.extend(utc);

export const UpwardTimer: React.FC<UpwardTimerPropsInterface> = ({ startTime }) => {
  const [elapsedTime, setElapsedTime] = useState<string>("");

  useEffect(() => {
    if (startTime) {
      const interval = setInterval(() => {
        const now = dayjs.utc();
        const start = dayjs.utc(startTime);
        const diff = dayjs.duration(now.diff(start));

        const hours = diff.hours().toString().padStart(2, "0");
        const minutes = diff.minutes().toString().padStart(2, "0");
        const seconds = diff.seconds().toString().padStart(2, "0");

        const timeSpent = `${hours}:${minutes}:${seconds}`;
        setElapsedTime(timeSpent);
        document.title = `${timeSpent} - Time Tracker`;
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [startTime]);

  return (
    <Typography sx={{ fontSize: "3rem" }}>
      {elapsedTime || "00:00:00"}
    </Typography>
  );
};
